// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rbc-btn-group button{
    background-color: #fdf5f2;
    color:#ff6036 !important;
    border: none !important;
}
.rbc-btn-group button:hover , .rbc-btn-group button:focus{
    background-color: #fdf5f2;
    color:#ff6036 !important;
    border: none !important;
}
.rbc-active{
    background-color: white !important;
    box-shadow: none !important;
}

.rbc-toolbar-label{
    text-align: start !important;
    font-weight: 500;
}

.rbc-label {
    font-size: 12px;
}

.rbc-event, .rbc-day-slot .rbc-background-event{
    background-color:#f6f7ff !important;
    color:#82abe8 !important;
    margin: 3px;
    width: fit-content;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1) !important; /* Example shadow */
}

.rbc-today {
    background-color: none !important;
}
.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event {
    border: 1px solid #a1b0fd !important;
    min-height: 4% !important;
    height:4.5% !important
}
.rbc-events-container .rbc-event{
    width: fit-content !important;
}

.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event{
  display: block !important;
}
  .horizontal-scroller {
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: thin; /* For modern browsers */
    scrollbar-color: #888 #f1f1f1; /* For modern browsers */
    -ms-overflow-style: -ms-autohiding-scrollbar; /* For Internet Explorer and Edge */
  }
  
  .horizontal-scroller::-webkit-scrollbar {
    height: 8px;
  }
  
  .horizontal-scroller::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  .horizontal-scroller::-webkit-scrollbar-thumb {
    background: #888;
  }
  
  .horizontal-scroller::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  

  .pill-card {
    display: flex;
    align-items: center;
    background-color: white;
    padding: 5px 5px;
    padding-right: 15px;
    border-radius: 50px; /* This creates the pill shape */
    border: 1px solid #e6e6e6;
    margin-bottom: 10px;
    flex: 0 0 auto; /* Prevent flex items from growing or shrinking */
  }
  
  .avatar {
    width: 45px; /* Adjust size as needed */
    height: 45px;
    margin-right: 6px; /* Spacing between image and text */
  }
  
  .pill-card .card-info {
    text-align: left;
    flex: 1 1; /* Ensure that card-info takes up the remaining space */
  }
  
  .pill-card .card-title {
    white-space: nowrap; /* Prevent the text from wrapping */
    overflow: hidden; /* Hide text that doesn't fit in the container */
    text-overflow: ellipsis; /* Show ellipsis when text overflows */
    max-width: 140px; /* Set a maximum width for the title */
  }
  

  .p-datatable .p-datatable-header{
    background-color: white !important;
    border : none;
    border-bottom: 1px solid #eaeaea;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;

  }


  /* Target the last \`tr\` in the \`tbody\` */
.p-datatable .p-datatable-tbody > tr:last-child > td:first-child {
    /* Apply border-top-left-radius to the first \`td\` of the last \`tr\` */
    border-bottom-left-radius: 50%;
  }
  
  .p-datatable .p-datatable-tbody > tr:last-child{

    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;

  }
  .p-datatable .p-datatable-tbody > tr:last-child > td:last-child {
    /* Apply border-top-right-radius to the last \`td\` of the last \`tr\` */
    border-bottom-right-radius: 50%;
  }
  


   .patient-infoCaard {
      display: flex;
       align-items: center;
 }
    
 .patient-avatar {
       width: 30px;
       height: 30px;
       border-radius: 50%;
      margin-right: 10px;
     }
    `, "",{"version":3,"sources":["webpack://./src/assets/css/calendar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,kFAAkF,EAAE,mBAAmB;AAC3G;;AAEA;IACI,iCAAiC;AACrC;AACA;IACI,oCAAoC;IACpC,yBAAyB;IACzB;AACJ;AACA;IACI,6BAA6B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB,EAAE,wBAAwB;IAC/C,6BAA6B,EAAE,wBAAwB;IACvD,4CAA4C,EAAE,mCAAmC;EACnF;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB,EAAE,gCAAgC;IACrD,yBAAyB;IACzB,mBAAmB;IACnB,cAAc,EAAE,iDAAiD;EACnE;;EAEA;IACE,WAAW,EAAE,0BAA0B;IACvC,YAAY;IACZ,iBAAiB,EAAE,mCAAmC;EACxD;;EAEA;IACE,gBAAgB;IAChB,SAAO,EAAE,uDAAuD;EAClE;;EAEA;IACE,mBAAmB,EAAE,mCAAmC;IACxD,gBAAgB,EAAE,gDAAgD;IAClE,uBAAuB,EAAE,sCAAsC;IAC/D,gBAAgB,EAAE,sCAAsC;EAC1D;;;EAGA;IACE,kCAAkC;IAClC,aAAa;IACb,gCAAgC;IAChC,4BAA4B;IAC5B,2BAA2B;;EAE7B;;;EAGA,wCAAwC;AAC1C;IACI,oEAAoE;IACpE,8BAA8B;EAChC;;EAEA;;IAEE,8BAA8B;IAC9B,+BAA+B;;EAEjC;EACA;IACE,oEAAoE;IACpE,+BAA+B;EACjC;;;;GAIC;MACG,aAAa;OACZ,mBAAmB;CACzB;;CAEA;OACM,WAAW;OACX,YAAY;OACZ,kBAAkB;MACnB,kBAAkB;KACnB","sourcesContent":[".rbc-btn-group button{\n    background-color: #fdf5f2;\n    color:#ff6036 !important;\n    border: none !important;\n}\n.rbc-btn-group button:hover , .rbc-btn-group button:focus{\n    background-color: #fdf5f2;\n    color:#ff6036 !important;\n    border: none !important;\n}\n.rbc-active{\n    background-color: white !important;\n    box-shadow: none !important;\n}\n\n.rbc-toolbar-label{\n    text-align: start !important;\n    font-weight: 500;\n}\n\n.rbc-label {\n    font-size: 12px;\n}\n\n.rbc-event, .rbc-day-slot .rbc-background-event{\n    background-color:#f6f7ff !important;\n    color:#82abe8 !important;\n    margin: 3px;\n    width: fit-content;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1) !important; /* Example shadow */\n}\n\n.rbc-today {\n    background-color: none !important;\n}\n.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event {\n    border: 1px solid #a1b0fd !important;\n    min-height: 4% !important;\n    height:4.5% !important\n}\n.rbc-events-container .rbc-event{\n    width: fit-content !important;\n}\n\n.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event{\n  display: block !important;\n}\n  .horizontal-scroller {\n    overflow-x: auto;\n    white-space: nowrap;\n    scrollbar-width: thin; /* For modern browsers */\n    scrollbar-color: #888 #f1f1f1; /* For modern browsers */\n    -ms-overflow-style: -ms-autohiding-scrollbar; /* For Internet Explorer and Edge */\n  }\n  \n  .horizontal-scroller::-webkit-scrollbar {\n    height: 8px;\n  }\n  \n  .horizontal-scroller::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  \n  .horizontal-scroller::-webkit-scrollbar-thumb {\n    background: #888;\n  }\n  \n  .horizontal-scroller::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n  \n\n  .pill-card {\n    display: flex;\n    align-items: center;\n    background-color: white;\n    padding: 5px 5px;\n    padding-right: 15px;\n    border-radius: 50px; /* This creates the pill shape */\n    border: 1px solid #e6e6e6;\n    margin-bottom: 10px;\n    flex: 0 0 auto; /* Prevent flex items from growing or shrinking */\n  }\n  \n  .avatar {\n    width: 45px; /* Adjust size as needed */\n    height: 45px;\n    margin-right: 6px; /* Spacing between image and text */\n  }\n  \n  .pill-card .card-info {\n    text-align: left;\n    flex: 1; /* Ensure that card-info takes up the remaining space */\n  }\n  \n  .pill-card .card-title {\n    white-space: nowrap; /* Prevent the text from wrapping */\n    overflow: hidden; /* Hide text that doesn't fit in the container */\n    text-overflow: ellipsis; /* Show ellipsis when text overflows */\n    max-width: 140px; /* Set a maximum width for the title */\n  }\n  \n\n  .p-datatable .p-datatable-header{\n    background-color: white !important;\n    border : none;\n    border-bottom: 1px solid #eaeaea;\n    border-top-right-radius: 50%;\n    border-top-left-radius: 50%;\n\n  }\n\n\n  /* Target the last `tr` in the `tbody` */\n.p-datatable .p-datatable-tbody > tr:last-child > td:first-child {\n    /* Apply border-top-left-radius to the first `td` of the last `tr` */\n    border-bottom-left-radius: 50%;\n  }\n  \n  .p-datatable .p-datatable-tbody > tr:last-child{\n\n    border-bottom-left-radius: 50%;\n    border-bottom-right-radius: 50%;\n\n  }\n  .p-datatable .p-datatable-tbody > tr:last-child > td:last-child {\n    /* Apply border-top-right-radius to the last `td` of the last `tr` */\n    border-bottom-right-radius: 50%;\n  }\n  \n\n\n   .patient-infoCaard {\n      display: flex;\n       align-items: center;\n }\n    \n .patient-avatar {\n       width: 30px;\n       height: 30px;\n       border-radius: 50%;\n      margin-right: 10px;\n     }\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
